export default __webpack_public_path__ + "static/media/visa.93ed20c6.svg";